import React, { forwardRef } from 'react'
import { GridProps } from './Grid.types'
import { StyledGrid } from './Grid.styles'

const Grid = forwardRef<HTMLDivElement, GridProps>(
  ({ children, ...props }, ref) => {
    return (
      <StyledGrid ref={ref} {...props}>
        {children}
      </StyledGrid>
    )
  }
)

Grid.displayName = 'Grid'

export default Grid
